import React from "react";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
function Parking() {
  return (
    <div className="bg-light py-4">

      <Container>

        {/* TITLE */}
        <h2 className="text-center mb-3">PARKEASE SYSTEM</h2>
        <p className="text-center text-muted mb-4">
          Parking Management System Demo Access
        </p>

        {/* 3 COLUMN LAYOUT */}
        <Row className="g-4">

          {/* ADMIN LOGIN */}
          <Col md={3}>
            <Card className="shadow-sm h-100">
              <Card.Body>
       <Button variant="primary" className="w-100">
                  Admin Login
                  </Button>
                <Form>
                  <Form.Group className="mb-2">
                    <Form.Label>ID</Form.Label>
                    <Form.Control type="text" value="admin@gmail.com" readOnly />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>Username</Form.Label>
                    <Form.Control type="text" value="admin" readOnly />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="text" value="123456" readOnly />
                  </Form.Group>

                 
                </Form>

              </Card.Body>
            </Card>
          </Col>
          

          {/* ATTENDANT LOGIN */}
          <Col md={3}>
            <Card className="shadow-sm h-100">
              <Card.Body>

               <Button variant="success" className="w-100">
                    Staff  Login 
                  </Button>
                <Form>
                  <Form.Group className="mb-2">
                    <Form.Label>ID</Form.Label>
                    <Form.Control type="text" value="tugume@gmail.com" readOnly />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>Username</Form.Label>
                    <Form.Control type="text" value="staff" readOnly />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="text" value="tugume@123" readOnly />
                  </Form.Group>

                 
                </Form>

              </Card.Body>
            </Card>
          </Col>
          {/* ATTENDANT LOGIN */}
          <Col md={3}>
            <Card className="shadow-sm h-100">
              <Card.Body>

               <Button variant="success" className="w-100">
                    Attendant  Login 
                  </Button>
                <Form>
                  <Form.Group className="mb-2">
                    <Form.Label>ID</Form.Label>
                    <Form.Control type="text" value="tugume@123gmail.com" readOnly />
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>Username</Form.Label>
                    <Form.Control type="text" value="attendant" readOnly />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="text" value="tugume@123" readOnly />
                  </Form.Group>

                 
                </Form>

              </Card.Body>
            </Card>
          </Col>

          {/* SYSTEM INFO */}
          <Col md={3}>
            <Card className="shadow-sm h-100">
              <Card.Body>

                <h5 className="text-center mb-3">How It Works</h5>

                <ul>
                  <li>Register incoming vehicles</li>
                  <li>Assign parking slots</li>
                  <li>Calculate parking fees</li>
                  <li>Generate daily & monthly reports</li>
                </ul>

                <p className="text-muted small">
                  This system helps manage parking operations efficiently with real-time tracking.
                </p>

              </Card.Body>
            </Card>
          </Col>

        </Row>

        {/* LIVE DEMO BUTTON */}
        <div className="text-center mt-4">
          <a
            href="https://parking.chrisalphatech.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button size="lg"
              style={{
                backgroundColor: "#0d6efd",
                border: "none"
              }}>
               Open Live Demo
            </Button>
          </a>
          
               <Link 
                  to="/parkease" 
                  style={{ 
          color: "#0d6eff", 
          fontWeight: "500",
          marginLeft: "20px"
        }}
                >
                  Read More 
                </Link>
                
                
        </div>

      </Container>

    </div>
  );
}

export default Parking;